import React, { Component } from 'react';
import { useState, useEffect } from 'react';
import { basePort, setTokenHeader, getUsernameJwt, headers, isExpiredJwt, IsMbrTempRole, getJwtFromCookies, getRoleJwt, renderRedirect } from "../../module_auth/AuthService"
import 'react-quill/dist/quill.snow.css';
import { ToastMessage } from "../../component/common/Toast"
import { ModalMessage, ModalNickname } from "../../component/common/Modal"
import { lazyReload, formatDate } from '../common/BaseUtil';
import { useNavigate } from "react-router-dom";
import '../../App.css';

export function MbrPvModiMypage() {
    const navigate = useNavigate();

    const [mbrId, setMbrId] = useState("");
    const [fullname, setFullname] = useState("");
    const [nickname, setNickname] = useState("");
    const [nicknameUpdateAt, setNicknameUpdateAt] = useState("");
    const [nicknameModi, setNicknameModi] = useState("");
    const [telno, setTelno] = useState("");
    const [email, setEmail] = useState("");
    // const [workCity, setWorkCity] = useState("0");
    // const [workTime, setWorkTime] = useState("0");
    // const [visaStat, setVisaStat] = useState("");
    // const [eduHist, setEduHist] = useState("");
    // const [resumeHist, setResumeHist] = useState("");
    // const [pvIntro, setPvIntro] = useState("");
    
    const [password, setPassword] = useState("");
    const [passwordRepeat, setPasswordRepeat] = useState("");
    const [accessToken, setAccessToken] = useState("");
    const [memberEntity, setMemberEntity] = useState("");

    const [redirectLogin, setRedirectLogin] = useState(false);
    //toast
    const [showToast, setShowToast] = useState(false);
    const [msgToast, setMsgToast] = useState("");

    // const [cityList, setCityList] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    //modal
    const [showModal, setShowModal] = useState(false);
    const [showModalNickname, setShowModalNickname] = useState(false);
    
    //닉네임 중복확인후 사용가능여부
    const [enableChangeNickname, setEnableChangeNickname] = useState(false);
    //닉네임 중복확인후 메세지
    const [messageChangeNickname, setMessageChangeNickname] = useState("");
    //닉네임 중복확인 여부
    const [validatedNickname, setValidatedNickname] = useState(false);
    //닉네임 최근 수정날짜 확인후 변경가능성 결정
    const [activeChangeNicknameModal, setActiveChangeNicknameModal] = useState(false);

    useEffect(() => {
        if(getJwtFromCookies() == null || isExpiredJwt(getJwtFromCookies()) || IsMbrTempRole(getJwtFromCookies())){
            //alert
            setRedirectLogin(true)
            setIsLoading(false)
        } else { 
            setAccessToken(getJwtFromCookies())
            setMbrId(getUsernameJwt(getJwtFromCookies()))
            // getCityList()
            setTokenHeader(getJwtFromCookies())
            fetch(basePort + '/get/pv/mypage', 
                {method:'GET', headers,
                body:JSON.stringify()})
                .then(response => response.json())
                .then(response => {
                    console.log("response.workCity: " + response.workCity)
                    setFullname(response.fullname)
                    setEmail(response.email)
                    setTelno(response.telno)
                    // setWorkCity(response.workCity)
                    // setWorkTime(response.workTime)
                    // setVisaStat(response.visaStat)
                    // setEduHist(response.eduHist)
                    // setResumeHist(response.resumeHist)
                    // setPvIntro(response.pvIntro)
                    setNickname(response.nickname)
                    setNicknameModi(response.nickname)
                    setNicknameUpdateAt(response.nicknameUpdateAt)
                    if(isMoreThan30DaysOld(response.nicknameUpdateAt)){
                        setActiveChangeNicknameModal(true)
                    }
            }).catch(error => console.log(error))
            .finally(() => {
                setIsLoading(false)
            })
        }
    }, []);

    function isMoreThan30DaysOld(dateString){
        const givenDate = formatDate(dateString);
        console.log(givenDate)
        const thirtyDaysAgo = new Date();
        console.log(thirtyDaysAgo)
        // Calculate the difference in milliseconds
        thirtyDaysAgo.setDate(thirtyDaysAgo.getDate() - 30);
        return givenDate < thirtyDaysAgo.toISOString().split('T')[0];
    }

        // function getCityList(){
        //     let url = basePort + '/get/config'
        //     fetch(url,
        //       {method:'GET', headers,
        //         body:JSON.stringify()})
        //         .then(response => response.json())
        //         .then(response => {
        //            console.log(response.cityEntityList)
        //            setCityList(response.cityEntityList)
        //       }).catch(error => console.log(error))
        // }

    function handlePassword(event) {
        setPassword(event.target.value);
        console.log(event.target.value)
    }

    function handlePasswordRepeat(event) {
        setPasswordRepeat(event.target.value);
    }

    function handleTelno(event) {
        setTelno(event.target.value);
        console.log(event.target.value)
    }

    // function handleWorkCity(event) {
    //     setWorkCity(event.target.value);
    // }

    // function handleWorkTime(event) {
    //     setWorkTime(event.target.value);
    // }

    // function handleVisaStat(event) {
    //     setVisaStat(event.target.value);
    // }

    // function handleEduHist(event) {
    //     setEduHist(event.target.value);
    // }

    // function handleResumeHist(event) {
    //     setResumeHist(event.target.value);
    // }

    // function handlePvIntro(event) {
    //     setPvIntro(event.target.value);
    // }

    function clickSubmit(event) {
        event.preventDefault();
        setAccessToken(getJwtFromCookies())
        fetch(basePort + '/update/pv/mypage', 
            {method:'post', headers,
                      body:JSON.stringify({
                        mbrId: mbrId,
                        fullname:fullname,
                        telno:telno,
                        email:email,
                                                // workCity:workCity,
                                                // workTime:workTime,
                                                // visaStat:visaStat,
                                                // eduHist:eduHist,
                                                // resumeHist:resumeHist,
                                                // pvIntro:pvIntro,
                        nickname:nickname
                    })})
                      .then(response => response.json())
                      .then(response => {
                        console.log(response.jwtToken)
                        if(response.validRequest){
                            fadeOutToast(response.validationMessage)
                            setTimeout(function() {
                                moveTo();
                            }.bind(this), 3000)
                        } else {
                            fadeOutToast(response.validationMessage)
                        }
            }).catch(error => console.log(error))
    }
    
    function fadeOutToast(msg){
        setToastMessage(true, msg)
        setTimeout(function() {
            setToastMessage(false, "")
        }.bind(this), 3000);
    }

    function setToastMessage(show, message){
        setShowToast(show)
        setMsgToast(message)
    }

    function changePasswordSubmit(event) {
        fetch(basePort + '/post/change/pwd', 
            {method:'post', headers,
                      body:JSON.stringify({
                        mbrId: mbrId,
                        newPassword:password,
                        newPasswordRepeat:passwordRepeat,
                    })})
                      .then(response => response.json())
                      .then(response => {
                        console.log(response.jwtToken)
                        if(response.validRequest){
                            fadeOutToast(response.validationMessage)
                            lazyReload()
                        } else {
                            fadeOutToast(response.validationMessage)
                        }
            }).catch(error => console.log(error))
    }

    function createNickname(event) {
        setMessageChangeNickname("")
        setAccessToken(getJwtFromCookies())
        console.log("createNickname")
        fetch(basePort + '/create/nickname', 
            {method:'post', headers,
                      body:JSON.stringify({})})
                      .then(response => response.json())
                      .then(response => {
                        console.log(response.value)
                        if(response.validRequest){
                            setNicknameModi(response.value)
                            setEnableChangeNickname(response.validRequest)
                            setMessageChangeNickname(response.validationMessage)
                            setValidatedNickname(true)
                        }
            }).catch(error => console.log(error))
    }

    function validateNickname(event) {
        setAccessToken(getJwtFromCookies())
        console.log("validateNickname")
        fetch(basePort + '/validate/nickname', 
            {method:'post', headers,
                      body:JSON.stringify({nickname:nicknameModi})})
                      .then(response => response.json())
                      .then(response => {
                        setValidatedNickname(true)
                        if(response.validRequest){
                            setEnableChangeNickname(response.validRequest)
                            setMessageChangeNickname(response.validationMessage)
                        } else {
                            setEnableChangeNickname(response.validRequest)
                            setMessageChangeNickname(response.validationMessage)
                        }
                        
            }).catch(error => console.log(error))
    }

    function dropMbrSubmit(event) {
        event.preventDefault();
        console.log("mbrId: " + mbrId)
        fetch(basePort + '/post/dropMbr', 
            {method:'post', headers,
                      body:JSON.stringify({
                        mbrId: 'm@google.com',
                        fullname:fullname,
                        telno:telno,
                        email:email,
                        password:password,
                    })})
                      .then(response => response.json())
                      .then(response => {
                        console.log(response.jwtToken)
                        if(response.jwtToken == null) {
                          
                        } else {
                       
                        }
            }).catch(error => console.log(error))
    }

    function closeModalBtn(){
        setShowModal(false)
    }

    function closeModalNicknameBtn(){
        setShowModalNickname(false)
        setNicknameModi(nickname)
        setValidatedNickname(false)
        setMessageChangeNickname("")
        setEnableChangeNickname(false)
    }

    function submitModalBtn(){
        setShowModal(false)
        changePasswordSubmit()
    }

    function submitModalNicknameBtn(){
        setShowModalNickname(false)
        setNickname(nicknameModi)
    }

    function clickModalBtn(){
        setShowModal(true)
    }

    function clickModalNicknameBtn(){
        if(activeChangeNicknameModal){
            setShowModalNickname(true)
        } else {
            setShowModalNickname(false)
            fadeOutToast("닉네임은 최초설정 또는 변경후 30일이 지나야 변경가능")
        }
    }

    function handleImage(){
        console.log("handleImage")
    }

    function moveTo() {
        navigate("/mbr_pv_mypage");
    }

    return (
        <div>
            {renderRedirect(redirectLogin, '/login')}
            <main class="page lanidng-page" style={{ opacity: isLoading ? 0.45 : 1, pointerEvents: isLoading ? 'none' : 'auto' }}>
                <section>
                    <div class="container" style={{paddingTop:'100px', marginTop: '10px', marginBottom: '10px'}}>
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><span>마이페이지</span></li>
                            <li class="breadcrumb-item"><span>개인회원정보</span></li>
                        </ol>
                        <div class="card">
                            <div class="card-body" style={{marginBottom: '10px'}}>
                                <form><label class="form-label">이름:</label><input class="form-control" type="text" value={fullname} disabled/></form>
                                <form style={{marginTop: '10px'}}><label class="form-label">이메일:</label><input class="form-control" type="text" readonly="" value={email} disabled/></form>
                                <form style={{marginTop: '10px'}}><label class="form-label">닉네임:</label>
                                    <div class="input-group">
                                        <input type="text" class="form-control" aria-describedby="basic-addon2" value={nickname} disabled/>
                                        <div class="input-group-append">
                                            <button class="btn btn-outline-secondary" type="button" style={{marginLeft:'5px'}} onClick={clickModalNicknameBtn}>변경</button>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <label class="form-label">
                                            <span style={{fontSize: '13px'}}>공백없이 한글, 영문, 숫자만 입력가능 (4자이상 20자이하), 닉네임은 최초설정 또는 변경후 30일이 지나야 변경가능, 최근변경일시: {formatDate(nicknameUpdateAt)}</span></label>
                                    </div>
                                </form>
                                <form style={{marginTop: '10px'}}><label class="form-label">전화번호:</label><input class="form-control" type="text" value={telno} onChange={handleTelno}/></form>
                                {/* <form style={{marginTop: '10px'}}><label class="form-label">근무도시:</label>
                                    <SelectCityList optionValue={workCity} cityList={cityList} handleWorkCity={handleWorkCity}/>
                                </form>
                                <form style={{marginTop: '10px'}}><label class="form-label">근무형태:</label>
                                    <select class="form-select" onChange={handleWorkTime} value={workTime}>
                                        <option value="0">선택</option>
                                        <option value="1">풀타임</option>
                                        <option value="2">파트타임</option>
                                        <option value="3">미니잡</option>
                                    </select>
                                </form>
                                <form style={{marginTop: '10px'}}><label class="form-label">비자상태:</label>
                                    <select class="form-select" onChange={handleVisaStat} value={visaStat}>
                                        <option value="0" selected>선택</option>
                                        <option value="1">학생비자</option>
                                        <option value="2">워킹홀리데이비자</option>
                                        <option value="3">취업준비비자</option>
                                        <option value="4">워킹비자</option>
                                    </select>
                                </form>
                                <form style={{marginTop:'10px', marginRight:'0px'}}>
                                    <label class="form-label">학력사항:</label>
                                    <div class="container" style={{minHeight:'350px', marginBottom:'10px'}}>
                                            <ReactQuill theme="snow" value={eduHist} onChange={setEduHist}
                                                style={{height: '300px', marginBottom:'10px'}}
                                                modules={{
                                                    toolbar: {
                                                        container: [
                                                            [{ header: '1' }, { header: '2' }, { header: [3, 4, 5, 6] }, { font: [] }],
                                                            [{ size: [] }],
                                                            ['bold', 'italic', 'underline', 'strike', 'blockquote'],
                                                            [{ list: 'ordered' }, { list: 'bullet' }],
                                                            ['image'],
                                                            ['clean'],
                                                            ['code-block']
                                                        ],
                                                        handlers: {
                                                            image: handleImage(),
                                                        },
                                                    },
                                                    
                                                }}
                                            />
                                    </div>
                                </form>
                                <form className="responsive-pv-mypage-editor">
                                    <label class="form-label" style={{marginBottom:'10px'}}>경력사항:</label>
                                    <div class="container" style={{minHeight:'350px', marginBottom:'10px'}}>
                                            <ReactQuill theme="snow" value={resumeHist} onChange={setResumeHist}
                                                style={{height: '300px', marginBottom:'10px'}}
                                                modules={{
                                                    toolbar: {
                                                        container: [
                                                            [{ header: '1' }, { header: '2' }, { header: [3, 4, 5, 6] }, { font: [] }],
                                                            [{ size: [] }],
                                                            ['bold', 'italic', 'underline', 'strike', 'blockquote'],
                                                            [{ list: 'ordered' }, { list: 'bullet' }],
                                                            ['image'],
                                                            ['clean'],
                                                            ['code-block']
                                                        ],
                                                        handlers: {
                                                            image: handleImage(),
                                                        },
                                                    },
                                                    
                                                }}
                                            />
                                    </div>
                                </form>
                                <form className="responsive-pv-mypage-editor">
                                    <label class="form-label" style={{marginBottom:'10px'}}>자기소개:</label>
                                    <div class="container" style={{minHeight:'350px', marginBottom:'10px'}}>
                                            <ReactQuill theme="snow" value={pvIntro} onChange={setPvIntro}
                                                style={{height: '300px', marginBottom:'10px'}}
                                                modules={{
                                                    toolbar: {
                                                        container: [
                                                            [{ header: '1' }, { header: '2' }, { header: [3, 4, 5, 6] }, { font: [] }],
                                                            [{ size: [] }],
                                                            ['bold', 'italic', 'underline', 'strike', 'blockquote'],
                                                            [{ list: 'ordered' }, { list: 'bullet' }],
                                                            ['image'],
                                                            ['clean'],
                                                            ['code-block']
                                                        ],
                                                        handlers: {
                                                            image: handleImage(),
                                                        },
                                                    },
                                                    
                                                }}
                                            />
                                    </div>
                                </form>
                                */}
                            </div>
                            <form style={{textAlign: 'center', marginTop:'20px', marginBottom: '10px'}}>
                                <button class="btn btn-secondary" type="button" onClick={moveTo} style={{marginRight: '5px'}}>취소하기</button>
                                <button class="btn btn-primary" type="button" onClick={clickSubmit}>저장하기</button>
                            </form>
                        </div>
                        <div class="card" style={{marginTop:'20px'}}>
                            <div class="card-body" style={{marginBottom: '10px'}}>
                                <p class="card-text" style={{fontWeight: 'bold', marginTop: '10px'}}>비밀번호 변경</p>
                                <form><label class="form-label">새 비밀번호:</label><input class="form-control" type="password" onChange={handlePassword}/></form>
                                <form style={{marginTop: '10px'}}><label class="form-label">새 비밀번호 확인:</label><input class="form-control" type="password" onChange={handlePasswordRepeat}/></form>
                                <ul class="list-group"></ul>
                            </div>
                            <form style={{textAlign: 'center', marginBottom: '10px'}}><button class="btn btn-primary" type="button" onClick={clickModalBtn}>비밀번호 변경하기</button></form>
                        </div>
                    {/* end of container */}
                    <ToastMessage show={showToast} msg={msgToast} />
                    <ModalMessage show={showModal} closeBtn={closeModalBtn} submitBtn={submitModalBtn} title={"비밀번호 변경"} msg={"비밀번호를 변경하시겠습나까?"} />
                    <ModalNickname show={showModalNickname} closeBtn={closeModalNicknameBtn} submitBtn={submitModalNicknameBtn} title={"닉네임 변경"} msg={"닉네임을 변경하시겠습나까?"}
                        nickname={nicknameModi}
                        createNickname={createNickname}
                        validateNickname={validateNickname}
                        enableChangeNickname={enableChangeNickname}
                        messageChangeNickname={messageChangeNickname}
                        validatedNickname={validatedNickname}
                        setNicknameModi={setNicknameModi}
                        setValidatedNickname={setValidatedNickname}
                        setMessageChangeNickname={setMessageChangeNickname}
                        setEnableChangeNickname={setEnableChangeNickname}
                    />
                    </div>
                </section>
            </main>
            {isLoading && (
                <div
                    className="d-flex justify-content-center align-items-center"
                    style={{
                        position: 'fixed',
                        inset: 0,
                        backgroundColor: 'rgba(128, 128, 128, 0.22)',
                        zIndex: 1050
                    }}
                >
                    <div className="spinner-border text-primary" role="status" style={{ width: '3rem', height: '3rem' }}>
                        <span className="visually-hidden">Loading...</span>
                    </div>
                </div>
            )}
        </div>
    );
}